<template>
    <div v-if="videoID">
        <div
            :class="{ ['wistia_async_' + videoID]: true }"
            class="wistia_embed"
        >
            &nbsp;
        </div>
    </div>
</template>

<script>
export default {
    name: 'WistiaVideo',
    props: {
        videoID: String,
    },
    head: {
        script: function() {
            return [
                {
                    type: 'text/javascript',
                    src:
                        'https://fast.wistia.com/embed/medias/' +
                        this.videoID +
                        '.jsonp',
                    async: true,
                    body: true,
                },
                {
                    type: 'text/javascript',
                    src: 'https://fast.wistia.com/assets/external/E-v1.js',
                    async: true,
                    body: true,
                },
            ]
        },
    },
}
</script>

<style scoped>
.wistia_embed {
    padding-left: 15px;
    height: 225px;
    width: 400px;
}
.activeImage .wistia_embed {
    height: 450px;
    width: 100%;
    margin-left: -15px;
}
</style>
